const setLanguageToLC = (language: string) => {
  if (language) {
    localStorage.setItem('htlgt-language', language);
  }
};

export default setLanguageToLC;
